<script lang="ts">
  import LayoutStore from "@shared/svelte/Stores/LayoutStore";
  import Skeleton from "svelte-skeleton/Skeleton.svelte";

  $: mobileMode = $LayoutStore.isMobile;

  const lineHeight = 12;
  const radius = 12;
  const xVal = 30;

  const textWidth = mobileMode ? 200 : 400;
  $: itemCountX = mobileMode ? 0 : 120;

</script>

<div class="fizz-inset-horizontal-16" data-testid="product-lines-skeleton">
  <div
    class=" fizz-bordered fizz-inset-square-16 fizz-stack-16"
    class:fizz-flex-vertical={mobileMode}
  >
    <div class:fizz-flex-row={!mobileMode} class:fizz-space-between={!mobileMode}>
      <div class="fizz-flex-row-0">
        <!-- Product line image -->
        <Skeleton animate={true} height={72} width={72} />
        <div class="fizz-flow-4">
          <!-- Product Line info -->
          <Skeleton animate={true} height={150} width={textWidth}>
            <rect width={200} height={lineHeight} x={xVal} y={30} rx={radius} ry={radius} />
            <rect width={100} height={lineHeight} x={xVal} y={60} rx={radius} ry={radius} />
            <rect width={80} height={lineHeight} x={xVal} y={90} rx={radius} ry={radius} />
            <rect width={120} height={lineHeight} x={xVal} y={120} rx={radius} ry={radius} />
          </Skeleton>
        </div>
      </div>
      <!-- Price -->
      <div class="fizz-flex-row-4">
        <Skeleton animate={true} height={60} width={200}>
          <rect width="200" height="15" x="0" y="10" rx="12" ry="12" />
          <rect width="80" height="15" x={itemCountX} y="35" rx="12" ry="12" />
        </Skeleton>
      </div>
    </div>
  </div>
</div>
